module.exports = __webpack_public_path__ + "img/egyption greece-01.1a7213e0.png";